import React from 'react';

import {
  Element,
  FontType,
  Color,
  Typography
} from '@americanexpress/aqx-components';
import styles from '../__styles__/index.scss?modules';

export const Back = ({ content }) => {
  const { flagText, subHeader } = content;
  return (
    <Element className={styles.backOfTile}>
      <Typography
        $family={FontType.BentonMedium}
        $size={20}
        $lineHeight={28}
        Component="h3"
        theme={{
          textHeading: 5,
          color: Color.DeepBlue,
          padding: 'none',
          marginTop: 15,
          marginBottom: 5,
          marginLeft: 20,
          marginRight: 20
        }}
      >
        {subHeader}
      </Typography>
      <Typography
        $family={FontType.HelveticaRegular}
        $size={15}
        $lineHeight={22}
        theme={{ marginBottom: 15, marginLeft: 20, marginRight: 15 }}
      >
        {flagText}
      </Typography>
    </Element>
  );
};
